const normalizeSoftwareValue = (value) => {
  if (typeof value !== 'string') {
    return '';
  }

  return value.trim();
};

export const isSoftwareJobComplete = (job) => {
  const softwareDone = normalizeSoftwareValue(job?.SoftwareDone);
  return softwareDone !== '';
};

export const hasEligibleSoftwareType = (job) => {
  const softwareType = normalizeSoftwareValue(job?.SoftwareType);
  return softwareType !== '' && softwareType.toUpperCase() !== 'STD';
};

export const isSoftwareViewJob = (job, options = {}) => {
  const { includeCompleted = false } = options;

  if (!job || !hasEligibleSoftwareType(job)) {
    return false;
  }

  if (!includeCompleted && isSoftwareJobComplete(job)) {
    return false;
  }

  return true;
};

export const compareSoftwareDueDates = (leftJob, rightJob) => {
  const leftDue = leftJob?.SoftwareDue;
  const rightDue = rightJob?.SoftwareDue;

  if (!leftDue && !rightDue) return 0;
  if (!leftDue) return 1;
  if (!rightDue) return -1;

  const leftDate = new Date(leftDue);
  const rightDate = new Date(rightDue);

  if (Number.isNaN(leftDate.getTime()) && Number.isNaN(rightDate.getTime())) return 0;
  if (Number.isNaN(leftDate.getTime())) return 1;
  if (Number.isNaN(rightDate.getTime())) return -1;

  return leftDate - rightDate;
};

export const sortJobsBySoftwareDue = (jobs) => {
  if (!Array.isArray(jobs)) {
    return [];
  }

  return [...jobs].sort(compareSoftwareDueDates);
};